import { FC, ReactNode } from "react";
import { CustomThemeProvider } from "./customThemeProvider";
import { UserProvider } from "./userProvider";
import { EventProvider } from "./EventProvider";
import { SessionProvider } from "./SessionProvider";
import { PermissionProvider } from "./PermissionProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ReviewProvider } from "./ReviewProvider";
import { CommentProvider } from "./CommentProvider";

export const Providers: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <CustomThemeProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <UserProvider>
                    <PermissionProvider>
                        <EventProvider>
                            <SessionProvider>
                                <ReviewProvider>
                                    <CommentProvider>
                                        {children}
                                    </CommentProvider>
                                </ReviewProvider>
                            </SessionProvider>
                        </EventProvider>
                    </PermissionProvider>
                </UserProvider>
            </LocalizationProvider>
        </CustomThemeProvider>
    );
}